import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import './index.css';
import oauth from './components/common/oauth';
import ProfileContainer from './components/profile/ProfileContainer';
import Terms from './components/terms/Terms';
import PrivacyPolicy from './components/policy/PrivacyPolicy';
import PrivacyPledge from './components/policy/PrivacyPledge';
import Config from './Config';
import Home from './components/Home';
import UserContextProvider from './components/context/UserContextProvider';
import HeaderContainer from './components/common/HeaderContainer';
import FooterContainer from './components/common/FooterContainer';

class AppComponent extends React.Component {
  constructor(props) {
    super(props);
    // console.log(localStorage.getItem('dlinkuser'));
    let user = {};
    if (localStorage.getItem('dlinkuser')) {
      user = JSON.parse(localStorage.getItem('dlinkuser'));
    }
    if (user && user.access_token) {
      Config.curUser = user;
      if (Config.curUser.api_site) {
        Config.baseUrl = 'https://' + Config.curUser.api_site + '/';
      }
    }
  }

  render() {
    return (
      <Router basename={Config.rootPath}>
        <UserContextProvider>
          <HeaderContainer />
          <Route exact path="/" component={Home} />
          <Route exact path="/profile" component={ProfileContainer} />
          <Route exact path="/oauth" component={oauth} />
          <Route exact path="/terms-of-use" component={Terms} />
          <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          <Route exact path="/privacy-pledge" component={PrivacyPledge} />
          <FooterContainer />
        </UserContextProvider>
      </Router>
    );
  }
}

ReactDOM.render(<AppComponent />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js